/**
 * @generated SignedSource<<4d2405bb3ab224300ec01e8c69b9a75c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTaskPortalConfigInput = {
  psaTaskId: string;
  legacyPsaTaskId?: string | null;
  clientOrgId?: string | null;
  psaMilestoneId?: string | null;
  psaProjectId?: string | null;
  legacyPsaProjectId?: string | null;
  requiresClientSignoff?: boolean | null;
  signoffApproverForecastPersonId?: number | null;
  signoffApproverPortalUserId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTaskPortalConfigMutation$variables = {
  input: UpdateTaskPortalConfigInput;
};
export type updateTaskPortalConfigMutation$data = {
  readonly updateTaskPortalConfig: {
    readonly task: {
      readonly id: string;
      readonly portalConfig: {
        readonly requiresClientSignoff: boolean | null;
        readonly signoffApproverPortalUserId: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateTaskPortalConfigMutation = {
  variables: updateTaskPortalConfigMutation$variables;
  response: updateTaskPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTaskPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateTaskPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskPortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresClientSignoff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffApproverPortalUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0adcd58e1cc4d9908be17baebf1872b0",
    "id": null,
    "metadata": {},
    "name": "updateTaskPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateTaskPortalConfigMutation(\n  $input: UpdateTaskPortalConfigInput!\n) {\n  updateTaskPortalConfig(input: $input) {\n    task {\n      id\n      portalConfig {\n        requiresClientSignoff\n        signoffApproverPortalUserId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5a62620a9f897e6f27164474fb50710";

export default node;
